import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ReporteLiderComponent from "../../../components/comisionesAnualidad/reporteLider/ReporteLider";
import { ReporteLiderStore, reporteLiderStore } from "./ReporteLider.store";
import {
  ReporteLiderDispatcher,
  reporteLiderDispatcher
} from "./ReporteLider.dispatcher";
import Layout from "../../../components/layout";

interface Props extends ReporteLiderStore, ReporteLiderDispatcher {}
interface State {}

@Router()
@ReduxConnect(reporteLiderStore, reporteLiderDispatcher)
export default class ReporteLiderContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Reporte Líder Comercial - Anualidades" />
          <ReporteLiderComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
